const pluralizeWord = (word: string) => {
  const lowerWord = word.toLowerCase();

  if (lowerWord === "staff" || lowerWord.endsWith("s")) return word;
  if (/[^aeiou]y$/i.test(word)) return `${word.slice(0, -1)}ies`;
  if (/(?:ch|sh|x|z)$/i.test(word)) return `${word}es`;

  return `${word}s`;
};

export const pluralizePreferredStaffTerm = (term = "") => {
  const trimmedTerm = term.trim();

  if (!trimmedTerm) return "";

  return trimmedTerm.replace(/([^\s]+)$/, (word) => pluralizeWord(word));
};
